import React from 'react';

import blankFile from "../../../../assets/svg/blankFile.svg"
import video from "../../../../assets/svg/video.svg"
import music from "../../../../assets/svg/music.svg"
// import folder from "../../../../assets/svg/folder.svg"
import docx from "../../../../assets/svg/docx.svg"
import ppt from "../../../../assets/svg/ppt.svg"
import url from "../../../../assets/svg/url.svg"
import zip from "../../../../assets/svg/zip.svg"
import pdf from "../../../../assets/img/pdf.png"
import xlsx from "../../../../assets/svg/ExcelIcon.svg";
import image from "../../../../assets/svg/imageicon.svg";
import formats from '../../../../helpers/MediaFormats';

const FileIcon = ({ fileName }) => {

  // const type = fileName?.split(".").pop() || null;

  // switch (type) {
  //   case 'folder':
  //     return <img src={folder} alt="" />;

  //   case 'mp4':
  //   case 'webm':
  //     return <img src={video} alt="" />;

  //   case 'mp3':
  //   case 'wav':
  //     return <img src={music} alt="" />;

  //   case 'pdf':
  //     return <img src={pdf} alt="" width={16} height={16} />;

  //   case 'ppt':
  //   case 'pptx':
  //     return <img src={ppt} alt="" />;

  //   case "doc":
  //   case "docx":
  //     return <img src={docx} alt="" />;

  //   case "url":
  //     return <img src={url} alt="" />;

  //   case "zip":
  //     return <img src={zip} alt="" />;

  //   default:
  //     return <img src={blankFile} alt="" />;
  // }

  if(fileName) {
    const fileType =  fileName?.split(".").pop();
    const supportedFormats = Object.values(formats).flat();
    
    if (supportedFormats.includes(fileType)) {
      const findKeyByValue = (value, obj) => {
        for (let key in obj) {
          if (obj[key].includes(value)) {
            return key;
          }
        }
        return null;
      };

      const fileTypeKey = findKeyByValue(fileType, formats);

      if (fileTypeKey) {
        switch (fileTypeKey) {
          case "video":
            return <img src={video} alt="" />;

          case "audio":
            return <img src={music} alt="" />;
             
          case "word":
            return <img src={docx} alt="" />;

          case "pdf":
            return <img src={pdf} alt="" width={16} height={16} />;

          case "ppt":
            return <img src={ppt} alt="" />;

          case "zip":
            return <img src={zip} alt="" />;

          case "image":
            return <img src={image} alt="" />;

          case "url":
            return <img src={url} alt="" />;

           case "xlsx":
            return <img src={xlsx} alt="" />;

          default:
            return <img src={blankFile} alt="" />;
        }
        
      } else {
        return <img src={blankFile} alt="" />;
      }
    } else {
      return <img src={blankFile} alt="" />;
    }
  }
};

export default FileIcon;
